import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from '@/components/ui/toaster'
import { ThemeProvider } from '@/components/theme-provider'
import RouterList from './routes/root'
import { registerSW } from 'virtual:pwa-register'

import './index.css'

// Configurações para cada domínio
import domainConfigs, { DOMAINS } from './config/domain'
import { TenantProvider } from './context/tenant'
const config = domainConfigs[import.meta.env.VITE_DOMAIN] || domainConfigs.default

if (import.meta.env.VITE_DOMAIN === DOMAINS.TRISOLUTION) {
  import('@/style/trisolution.css')
} else if (import.meta.env.VITE_DOMAIN === DOMAINS.DS_CONSULTORIA) {
  import('@/style/ds_cons.css')
// } else if (import.meta.env.VITE_DOMAIN === DOMAINS.MD_TRIBUTARIA) {
//   import('@/style/md_tributaria.css')
// } else if (import.meta.env.VITE_DOMAIN === DOMAINS.GRUPO_BAHIA_SUL) {
//   import('@/style/grupo_bahia.css')
} else {
  import('@/style/klinger.css')
}
document.title = config.title || 'Aplicação'

// favicon
function ensureLink(rel: string, attrs: Record<string, string>) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v))
  return el
}

// ícone padrão
ensureLink('icon', { type: 'image/png', href: config.domainPath + config.icon })
// apple touch 180x180 (iOS Home Screen)
ensureLink('apple-touch-icon', {
  href: config.domainPath + config.icon,
  sizes: '180x180'
})

// meta application-name / apple-mobile-web-app-title
function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

setMeta('application-name', config.title)
setMeta('apple-mobile-web-app-title', config.title)
setMeta('theme-color', config.themeColor)
setMeta('background-color', config.backgroundColor)

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.documentElement
  Object.entries(config.theme).forEach(([key, value]) => {
    rootElement.style.setProperty(key, value as string)
  })
})

// SW
const updateSW = registerSW({
  onNeedRefresh() {
    updateSW(true) // força a atualização
  },
  onOfflineReady() {
    console.log('PWA offline ready')
  }
})

// Configuração base de cache para reduzir refetch agressivo sem alterar fluxos.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false
    },
    mutations: {
      retry: 0
    }
  }
})

// Renderiza a aplicação
const rootElement = document.getElementById('root')
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <TenantProvider>
          <>
            <RouterProvider router={RouterList} future={{ v7_startTransition: true }} />
            <Toaster />
            {import.meta.env.VITE_DEBUG === 'true' && <ReactQueryDevtools initialIsOpen={false} />}
          </>
        </TenantProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
} else {
  console.error('Elemento #root não encontrado. Verifique o arquivo index.html.')
}
